/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FeedItemListTypeEnum = "all" | "config_settings" | "contacts" | "containers" | "customs_types" | "default_folders" | "document_templates" | "document_types" | "email_templates" | "languages" | "miscellaneous_settings" | "ports" | "rate_cards" | "roles" | "shipment_types" | "shipments" | "shipping_lines" | "templates" | "vessels" | "voyages" | "%future added value";
export type ExternalTimelinePaginationQueryVariables = {
    count?: number | null;
    cursor?: string | null;
    group?: string | null;
    parentAbsoluteSlug?: string | null;
    slug?: string | null;
    type?: FeedItemListTypeEnum | null;
};
export type ExternalTimelinePaginationQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"ExternalTimeline_queryData">;
};
export type ExternalTimelinePaginationQuery = {
    readonly response: ExternalTimelinePaginationQueryResponse;
    readonly variables: ExternalTimelinePaginationQueryVariables;
};



/*
query ExternalTimelinePaginationQuery(
  $count: Int
  $cursor: String
  $group: String
  $parentAbsoluteSlug: String
  $slug: String
  $type: FeedItemListTypeEnum
) {
  ...ExternalTimeline_queryData
}

fragment ExternalFeedAttachments_data on AttachmentConnection {
  nodes {
    slug
    ...SmallAttachment_attachment
  }
}

fragment ExternalFeedImages_data on ImageConnection {
  edges {
    node {
      url
      shape
      overlay
    }
  }
}

fragment ExternalFeedItem_data on ExternalFeedItem {
  slug
  entity
  title
  titleImage {
    url
  }
  happenedAt
  images {
    edges {
      node {
        url
      }
    }
    ...ExternalFeedImages_data
  }
  contentLines {
    key
    text
  }
  attachments {
    nodes {
      slug
    }
    ...ExternalFeedAttachments_data
  }
  keyFields {
    key
    ...KeyField_data
  }
}

fragment ExternalTimeline_queryData on ApplicationQuery {
  externalFeedItemList(slug: $slug, type: $type, group: $group, parentAbsoluteSlug: $parentAbsoluteSlug) {
    feedItems(first: $count, after: $cursor) {
      edges {
        node {
          slug
          dayLabel
          ...ExternalFeedItem_data
          id
          __typename
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}

fragment KeyField_data on KeyField {
  label
  value {
    key
    ...SemanticString_data
  }
}

fragment SemanticString_data on SemanticString {
  text
}

fragment SmallAttachment_attachment on Attachment {
  url
  name
  contentType
  previewUrl
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "group"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "parentAbsoluteSlug"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "type"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v5 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExternalTimelinePaginationQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ExternalTimeline_queryData"
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExternalTimelinePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "group",
            "variableName": "group"
          },
          {
            "kind": "Variable",
            "name": "parentAbsoluteSlug",
            "variableName": "parentAbsoluteSlug"
          },
          {
            "kind": "Variable",
            "name": "slug",
            "variableName": "slug"
          },
          {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
          }
        ],
        "concreteType": "ExternalFeedItemList",
        "kind": "LinkedField",
        "name": "externalFeedItemList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ExternalFeedItemConnection",
            "kind": "LinkedField",
            "name": "feedItems",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ExternalFeedItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExternalFeedItem",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dayLabel",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "entity",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "titleImage",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "happenedAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageConnection",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ImageEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "shape",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "overlay",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SemanticString",
                        "kind": "LinkedField",
                        "name": "contentLines",
                        "plural": true,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AttachmentConnection",
                        "kind": "LinkedField",
                        "name": "attachments",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Attachment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "contentType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "previewUrl",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "KeyField",
                        "kind": "LinkedField",
                        "name": "keyFields",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "label",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SemanticString",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": (v5/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "ExternalTimeline_feedItemList_feedItems",
            "kind": "LinkedHandle",
            "name": "feedItems"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5347dabf31c1d1abd2a134f1393e81d8",
    "id": null,
    "metadata": {},
    "name": "ExternalTimelinePaginationQuery",
    "operationKind": "query",
    "text": "query ExternalTimelinePaginationQuery(\n  $count: Int\n  $cursor: String\n  $group: String\n  $parentAbsoluteSlug: String\n  $slug: String\n  $type: FeedItemListTypeEnum\n) {\n  ...ExternalTimeline_queryData\n}\n\nfragment ExternalFeedAttachments_data on AttachmentConnection {\n  nodes {\n    slug\n    ...SmallAttachment_attachment\n  }\n}\n\nfragment ExternalFeedImages_data on ImageConnection {\n  edges {\n    node {\n      url\n      shape\n      overlay\n    }\n  }\n}\n\nfragment ExternalFeedItem_data on ExternalFeedItem {\n  slug\n  entity\n  title\n  titleImage {\n    url\n  }\n  happenedAt\n  images {\n    edges {\n      node {\n        url\n      }\n    }\n    ...ExternalFeedImages_data\n  }\n  contentLines {\n    key\n    text\n  }\n  attachments {\n    nodes {\n      slug\n    }\n    ...ExternalFeedAttachments_data\n  }\n  keyFields {\n    key\n    ...KeyField_data\n  }\n}\n\nfragment ExternalTimeline_queryData on ApplicationQuery {\n  externalFeedItemList(slug: $slug, type: $type, group: $group, parentAbsoluteSlug: $parentAbsoluteSlug) {\n    feedItems(first: $count, after: $cursor) {\n      edges {\n        node {\n          slug\n          dayLabel\n          ...ExternalFeedItem_data\n          id\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n}\n\nfragment KeyField_data on KeyField {\n  label\n  value {\n    key\n    ...SemanticString_data\n  }\n}\n\nfragment SemanticString_data on SemanticString {\n  text\n}\n\nfragment SmallAttachment_attachment on Attachment {\n  url\n  name\n  contentType\n  previewUrl\n}\n"
  }
};
})();
(node as any).hash = '22e32614cbf08bf982dd5755954528ce';
export default node;
